import { encode } from 'js-base64'

export const hash = (item) => encode(JSON.stringify(item))
